import { Link } from "react-router-dom";
import { PRIVACIDADE } from "@nhomi/conteudo";
import { TopBar } from "@/ui/primitives";
import { TextoLongo } from "@/ui/TextoLongo";

/* ============================================================
   Política de privacidade

   Fica FORA do Guard: as lojas exigem que a URL abra sem login, e quem
   está decidindo se instala o app é exatamente quem ainda não tem conta.

   O TEXTO NÃO MORA MAIS AQUI. Ele é o mesmo que o app nativo mostra, e
   enquanto estava escrito duas vezes a versão do app já tinha perdido
   todos os destaques. Agora os dois leem `@nhomi/conteudo` — e mexer na
   política é mexer lá, uma vez.

   O que continua nesta tela é o que é DESTE lado: a barra de cima e o
   link para o "sobre", que é navegação e não conteúdo.
   ============================================================ */

export function Privacidade() {
  return (
    <main className="screen">
      <TopBar title="Privacidade" back="/" />
      <div className="screen-body pad texto-longo selecionavel">
        <TextoLongo blocos={PRIVACIDADE} />

        <p className="fine">
          <Link to="/sobre">Sobre o Nhomi</Link>
        </p>
        <div className="gap" />
      </div>
    </main>
  );
}
